import styled from 'styled-components';

interface IContainerProps {
  currentStep: number;
  step: number;
}

export const Container = styled.form<IContainerProps>`
  transition: opacity 0.3s ease-in, height 0.3s ease-out 0.3s;
  overflow: hidden;

  opacity: ${({ currentStep, step }) => (currentStep === step ? 1 : 0)};
`;
